/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/lift_open': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M11.5 23.207l-2.854-2.853.708-.708 2.146 2.147 2.146-2.147.708.708z"/><path pid="1" d="M11.5 20.207l-2.854-2.853.708-.708 2.146 2.147 2.146-2.147.708.708z"/><path pid="2" d="M11.5 17.207l-2.854-2.853.708-.708 2.146 2.147 2.146-2.147.708.708zM22.646 12.354L20.5 10.207l-2.146 2.146-.708-.707L20.5 8.792l2.854 2.854z"/><path pid="3" d="M22.646 15.354L20.5 13.207l-2.146 2.146-.708-.707 2.854-2.854 2.854 2.854z"/><path pid="4" d="M22.646 18.354L20.5 16.207l-2.146 2.146-.708-.707 2.854-2.854 2.854 2.854zM15 4h2v24h-2zM4.5 32H0v-4.5h1V31h3.5zM32 32h-4.5v-1H31v-3.5h1zM32 4.5h-1V1h-3.5V0H32zM1 4.5H0V0h4.5v1H1z"/>'
  }
})
